// Resume Auto Apply ********************************************************************************
// pathname: /v1/resume/auto-apply
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi';
import { ApiResumeAutoApplyOk } from 'src/types/v1-api-types';

interface SwrResumeAutoApplyProps {
  locale?: Locale;
  shouldFetch?: boolean;
}

export const useSwrResumeAutoApply = (props: SwrResumeAutoApplyProps) => {
  const {
    locale = 'ro',
    shouldFetch = true,
  } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiResumeAutoApplyOk>({
    url: '/v1/resume/auto-apply',
    shouldFetch,
    locale,
    apiOptions: {
      dedupingInterval: 60 * 1000,
      revalidateOnFocus: false,
    },
  });

  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
